import React, { useEffect } from 'react';

import ProfileApplicantVitals from './Vitals';

const ProfilePolicy = (props) => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: mount-only init
    useEffect(() => {
        props.doGetPolicy();
    }, []);

    return (
        <React.Fragment>
            <ProfileApplicantVitals {...props} />
            {/*<ProfileApplicantSales {...props} />*/}
            {/*<ProfileApplicantServicing {...props} />*/}
        </React.Fragment>
    );
};

export default ProfilePolicy;
